import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselDot = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 4, width: 8, height: 8, rx: 4, fill: "#DEDEE4" }));
const ForwardRef = forwardRef(SvgCarouselDot);
export { ForwardRef as ReactComponent };
